import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import classNames from 'classnames';
import get from 'lodash.get';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Box, Link } from '@miro-site/core';
import theme from './theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FooterLinksContainer = styled(Box).attrs({
  $styles: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: ['center', 'center', undefined],
    flex: ['0 0 100%', '0 0 100%', null]
  },
  $mt: [20, 20, null]
}).withConfig({
  displayName: "FooterLinks__FooterLinksContainer",
  componentId: "sc-1rsn5ej-0"
})([""]);
var Copyright = styled(Box).attrs({
  $styles: {
    fontSize: theme.footer.links.bottom.fontSize,
    lineHeight: theme.footer.links.bottom.lineHeight,
    color: theme.colors.primaryWhite
  },
  $mr: theme.footer.copyright.margin.right
}).withConfig({
  displayName: "FooterLinks__Copyright",
  componentId: "sc-1rsn5ej-1"
})([""]);
var CopyrightLink = styled(Link).withConfig({
  displayName: "FooterLinks__CopyrightLink",
  componentId: "sc-1rsn5ej-2"
})(["", ""], function (props) {
  return props.theme.normalizeStyles(theme.footer.links.bottom);
});
var FooterLink = styled(Link).attrs({
  $mr: theme.footer.copyrightLink.margin.right
}).withConfig({
  displayName: "FooterLinks__FooterLink",
  componentId: "sc-1rsn5ej-3"
})(["", " &:last-child{margin-right:0;}"], function (props) {
  return props.theme.normalizeStyles(theme.footer.links.bottom);
});

var toggleOneTrust = function toggleOneTrust(event) {
  var toggleInfoDisplay = get(window, 'OneTrust.ToggleInfoDisplay');

  if (!toggleInfoDisplay) {
    return;
  }

  event.preventDefault();
  toggleInfoDisplay === null || toggleInfoDisplay === void 0 ? void 0 : toggleInfoDisplay();
};

var shouldToggleOneTrust = function shouldToggleOneTrust(path) {
  return path.includes('manage-cookies') || path.includes('ccpa');
};

var FooterLinks = function FooterLinks(props) {
  var links = props.links;
  var year = new Date().getFullYear();

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isInUS = _React$useState4[0],
      setIsInUS = _React$useState4[1];

  useEffect(function () {
    var intervalOneTrust = setInterval(function () {
      var _window$OneTrust;

      if (typeof ((_window$OneTrust = window.OneTrust) === null || _window$OneTrust === void 0 ? void 0 : _window$OneTrust.getGeolocationData) === 'function') {
        clearInterval(intervalOneTrust);
        var geoLocationData = window.OneTrust.getGeolocationData();
        setIsInUS("".concat(geoLocationData.country).toUpperCase() === 'US');
        setLoading(false);
      }
    }, 100);
    return function () {
      clearInterval(intervalOneTrust);
    };
  }, []);
  return /*#__PURE__*/_jsxs(FooterLinksContainer, {
    children: [/*#__PURE__*/_jsxs(Copyright, {
      children: ["\xA9 ", year, ' ', /*#__PURE__*/_jsx(CopyrightLink, {
        href: "https://miro.com/",
        $color: "white",
        $size: "medium",
        children: "Miro"
      })]
    }), links.map(function (link, index) {
      if (!isInUS && link.path.includes('ccpa')) {
        return null;
      }

      return /*#__PURE__*/_jsx(FooterLink, {
        href: link.path,
        $color: "white",
        className: classNames('fade fade-in', {
          show: !loading
        }),
        onClick: shouldToggleOneTrust(link.path) ? toggleOneTrust : undefined,
        children: link.title
      }, index);
    })]
  });
};

export default FooterLinks;